import React from "react";
import FeedbackBanner from "../../general/correct-feedback/FeedbackBanner";
import HtmlContent from "../../general/html-content/HtmlContent";

const ImageQuizQuestion = ({
  question,
  audioPath,
  options,
  selectedOption,
  optionStatuses,
  onOptionClick,
  showCheckButton,
  canCheck,
  onCheck,
  feedbackVisible,
  feedback,
  onCloseFeedback,
  showNextButton,
  onNext,
  showFinishButton,
  onFinish,
}) => {
  return (
    <>
      {question && (
        <div className="test-question question-title" dangerouslySetInnerHTML={{ __html: question }} />
      )}

      {audioPath && (
        <div className="image-quiz-audio">
          <audio controls src={audioPath}>
            Your browser does not support the audio element.
          </audio>
        </div>
      )}

      <div className="image-quiz-options">
        {(options || []).map((option) => {
          const selectedOptions = Array.isArray(selectedOption)
            ? selectedOption
            : selectedOption
              ? [selectedOption]
              : [];
          const isSelected = selectedOptions.includes(option.id);
          const status = optionStatuses[option.id];
          const className = [
            "image-quiz-option",
            isSelected ? "selected" : "",
            status === "correct" ? "correct" : "",
            status === "incorrect" ? "incorrect" : "",
          ]
            .filter(Boolean)
            .join(" ");

          return (
            <button
              type="button"
              key={option.id}
              className={className}
              onClick={() => onOptionClick(option.id)}
            >
              <span className="image-quiz-option-marker">{option.id}</span>
              {option.imgPath ? (
                <img src={option.imgPath} alt={option.text || `Option ${option.id}`} />
              ) : (
                <HtmlContent className="image-quiz-option-placeholder" html={option.text || option.id} />
              )}
              {option.text && <HtmlContent className="image-quiz-option-caption" html={option.text} />}
            </button>
          );
        })}
      </div>

      {showCheckButton && canCheck && (
        <button className="btn checkAnswer" onClick={onCheck} style={{ display: "inline-block" }}>
          Перевірити
        </button>
      )}

      {feedbackVisible && <FeedbackBanner feedback={feedback} closeFeedback={onCloseFeedback} />}

      {showNextButton && (
        <button className="btn nextAnswer" onClick={onNext} style={{ display: "inline-block" }}>
          Наступне завдання
        </button>
      )}

      {showFinishButton && (
        <button className="btn nextAnswer" onClick={onFinish} style={{ display: "inline-block" }}>
          Завершити
        </button>
      )}
    </>
  );
};

export default ImageQuizQuestion;
